import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { MyCompanyCreate } from '@components/templates/myAccount/myCompanyCreate/MyCompanyCreate';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function MyCompanyCreatePage() {
    const { t } = useTranslation();

    const translations = {
        title: t('register-company-component.metatags.title'),
        description: t('register-company-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myCompaniesCreate,
        index: false,
    });

    return <MyCompanyCreate />;
}
